import type { NavigateProps as ReactRouterNavigateProps } from 'react-router-dom';

// eslint-disable-next-line no-restricted-imports
import { Navigate as ReactRouterNavigate } from 'react-router-dom';

import type { Routes } from '../../types';

export interface NavigateProps extends ReactRouterNavigateProps {
  to: '..' | '/' | Routes;
}
const Navigate = (props: NavigateProps) => {
  return <ReactRouterNavigate {...props} to={props.to} />;
};

export default Navigate;
